import { render, staticRenderFns } from "./Kinos.vue?vue&type=template&id=c0d26f32&"
import script from "./Kinos.vue?vue&type=script&lang=js&"
export * from "./Kinos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports